
import { defineComponent, onMounted, ref, computed, useSSRContext } from "vue";
import { Field } from "vee-validate";
import Subset from "@/views/pages/other/cooperationInSales/components/Subset.vue";
import Credit from "@/views/pages/other/cooperationInSales/components/Credit.vue";
import Details from "@/views/pages/other/cooperationInSales/components/Details.vue";
import PaymentRequestList from "@/views/pages/other/cooperationInSales/components/PaymentRequestList.vue";
import Desc from "@/views/pages/other/cooperationInSales/components/Desc.vue";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import { translate } from "@/core/services/HelpersFun";
import ApiService from "@/core/services/ApiService";
import userInfo from "@/core/services/UserInfo";
import { useRouter } from "vue-router";
import { ElNotification } from "element-plus/es";

export default defineComponent({
  name: "kt-cooperation-in-sale",
  components: {
    Subset,
    Credit,
    Details,
    PaymentRequestList,
    Desc,
    Field,
  },
  setup() {
    setCurrentPageBreadcrumbs(translate("نمایندگی"), []);

    const status_modal = ref(false);
    const req_form = ref(false);
    const rules_accept = ref(false);
    const req = ref({
      name: "",
      mobile: "",
      job: "",
      sales_history: "",
      // time_in_month: "",
      phone: "",
      description: "",
      // why_inboxino: "",
      type: "",
    });
    const router = useRouter();
    const user = computed(() => {
      return userInfo.getUser();
    });

    const handleClose = (done: () => void) => {
      // ElMessageBox.confirm('Are you sure to close this dialog?')
      // .then(() => {
      // done()
      status_modal.value = true;
      // })
      // .catch(() => {
      // catch error
      // })
    };

    const send_info = () => {
      // console.log(req.value);

      ApiService.post("agent/request", req.value)
        .then(({ data }) => {
          ElNotification({
            title: "تایید",
            message: "اطلاعات با موفقیت ارسال شد.",
            type: "success",
          });
          router.push("/dashboard");
          // setTimeout(() => {
          //   location.reload();

          // }, 500);
        })
        .catch((e) => {
          ElNotification({
            title: "خطا",
            message: e.response.data.validation_message,
            type: "error",
          });
        });
    };

    onMounted(() => {
      if (user.value.cooperation_status !== "accepted") {
        status_modal.value = true;
      } else {
        status_modal.value = false;
      }

      req.value = {
        name: user.value?.first_name + " " + user.value?.last_name,
        mobile: user.value?.mobile?.replace("+", ""),
        job: "",
        sales_history: "",
        // time_in_month: "",
        phone: "",
        description: "",
        // why_inboxino: "",
        type: "",
      };
    });

    return {
      status_modal,
      req_form,
      user,
      req,
      send_info,
      handleClose,
      rules_accept,
    };
  },
});
